import {Box, Typography, useTheme} from "@mui/material";
import {NavBar} from "../../organisms/NavBar/NavBar";
import {useGetNbaMatchups} from "../../../hooks/getNbaMatchups/getNbaMatchups";
import {useLocation} from "react-router-dom";
import {NbaMatchupSubNav} from "./components/NbaMatchupSubNav";
import qs from "qs";
import {TrendFinder} from "../QueryPage/components/TrendFinder/TrendFinder";
import {useSdqlQuery} from "../../../hooks/utilHooks/useNbaSdqlQuery/useSdqlQuery";
import {getActiveTrends, getCurrentMatchup} from "../../../utils/helperFunctions";
import {useGetSearchTrends} from "../../../hooks/getSearchTrends/getSearchTrends";
import {useGetNflMatchups} from "../../../hooks/getNflMatchups/getNflMatchups";
import {useGetNcaafbMatchups} from "../../../hooks/getNcaafbMatchups/getNcaafbMatchups";
import {ActiveTrendsRow} from "./components/ActiveTrendsRow";
import {Fragment, useState} from "react";
import {useGetNcaabbMatchups} from "../../../hooks/getNcaabbMatchups/getNcaabbMatchups";
import {useAuth} from "../../../AuthContext/authContext";
import {useGetSelectedSport} from "../../../hooks/utilHooks/useGetSelectedSport/useGetSelectedSport";

export const MatchupTeamsPage = () => {

    const {loggedInUserEmail} = useAuth()
    const {data: nbaData, error: nbaError, loading: nbaLoading} = useGetNbaMatchups(false, false, !!loggedInUserEmail) || {}
    const {data: nflData, error: nflError, loading: nflLoading} = useGetNflMatchups(true, false, !!loggedInUserEmail) || {}
    const {data: ncaafbData, error: ncaafbError, loading: ncaafbLoading} = useGetNcaafbMatchups(false, false, !!loggedInUserEmail) || {}
    const {data: ncaabbData, error: ncaabbError, loading: ncaabbLoading} = useGetNcaabbMatchups(false, false, !!loggedInUserEmail) || {}
    const [switchTeamAndOTeam, setSwitchTeamAndOTeam] = useState(false);
    const location = useLocation();
    const cleanQueryString = location.search.startsWith('?') ?
        location.search.slice(1) : location.search;
    const parsedParams = qs.parse(cleanQueryString);
    const {view} = parsedParams;
    const showTrendFinder = view === 'trend-finder';
    const pathSegments = location.pathname.split('/');
    const {getSelectedSport} = useGetSelectedSport()
    const sport = getSelectedSport();

    // let sport: 'nba' | 'ncaabb' | 'nfl' | 'ncaafb' = 'nfl';
    // if (pathname.includes('nfl')) sport = 'nfl'
    // if (pathname.includes('nba')) sport = 'nba'
    // if (pathname.includes('ncaafb')) sport = 'ncaafb'
    // if (pathname.includes('ncaabb')) sport = 'ncaabb'

    let matchupsToUse = nbaData?.nbaMatchups;
    if (sport === 'nba') matchupsToUse = nbaData?.nbaMatchups;
    if (sport === 'nfl') matchupsToUse = nflData?.nflMatchups;
    if (sport === 'ncaafb') matchupsToUse = ncaafbData?.ncaafbMatchups;
    if (sport === 'ncaabb') matchupsToUse = ncaabbData?.ncaabbMatchups;

    const team = pathSegments[3];
    const oTeam = pathSegments[4];
    const date = pathSegments[5];
    const currentMatchup = getCurrentMatchup(matchupsToUse, team, oTeam, date) || {}

    const {
        teamActiveTrends,
        oTeamActiveTrends,
        overActiveTrends,
        underActiveTrends
    } = getActiveTrends(
        currentMatchup?.activeTrends,
        currentMatchup
    ) || {};

    const {
        queryString,
        handleSdqlStringChange
    } = useSdqlQuery(sport)

    const formattedLine = currentMatchup?.line <= 0 ? ` ${currentMatchup?.line}` : ` +${currentMatchup.line}`

    const {
        team: currentMatchupTeam,
        oTeam: currentMatchupOTeam,
        school,
        oSchool,
        site,
        streak,
        atsStreak,
        ouStreak,
        oStreak,
        oAtsStreak,
        oOuStreak,
        wins,
        losses,
        rest,
        oWins,
        oLosses,
        division,
        oDivision,
        conference,
        oConference,
        week,
        month,
        afterAllStarBreak,
        tournament,
        total,
        rank,
        oRank,
        avgPace,
        oppAvgPace,
        avgPoints,
        avgOPoints,
        oppAvgPoints,
        oppAvgOPoints,
        playoffs,
        round,
        seriesGame,
        seriesWins,
    } = currentMatchup || {};
    const theme = useTheme()

    const {data: searchTrendData} = useGetSearchTrends({
            sport,
            queryString,
            rest,
            team: currentMatchupTeam || '',
            oTeam: currentMatchupOTeam || '',
            site: site || '',
            line: +(currentMatchup?.line || 0),
            total: +(total || 0),
            oRest: +(currentMatchup?.oRest || 0),
            streak: +(streak || 0),
            oStreak: +(oStreak || 0),
            atsStreak: +(atsStreak || 0),
            oAtsStreak: +(oAtsStreak || 0),
            ouStreak: +(ouStreak || 0),
            oOuStreak: +(oOuStreak || 0),
            winPercentage: +(wins || 0) / (+(wins || 0) + +(losses || 0)),
            oWinPercentage:  +(oWins || 0) / (+(oWins || 0) + +(oLosses || 0)),
            division: division,
            oDivision: oDivision,
            conference: conference,
            oConference: oConference,
            tournament,
            avgPoints,
            avgOPoints,
            oppAvgPoints,
            oppAvgOPoints,
            week,
            month,
            afterAllStarBreak,
            rank,
            oRank,
            switchTeamAndOTeam,
            avgPace,
            playoffs,
            round,
            seriesGame: seriesGame || 0,
            seriesWins: seriesWins || 0,
            avgOPace: oppAvgPace,
        })
    const {teamTrends, oTeamTrends, seasonTrends} = searchTrendData?.searchTrends || {};
    let teamDisplayName = team;
    let oTeamDisplayName = oTeam;
    if(sport === 'ncaafb' || sport === 'ncaabb') {
        teamDisplayName = school
        oTeamDisplayName = oSchool
    }

    return (
        <Fragment>
            <NavBar/>
            <Box p={3} pt={2}>
                <Typography
                    component="p"
                    variant="h6"
                    align="center"
                    color={theme.palette.grey[500]}
                    fontWeight={100}
                    pl={3.5}
                    pr={3.5}
                >
                    {`${teamDisplayName}${formattedLine} 
                    vs ${oTeamDisplayName} (${currentMatchup?.total})`}
                </Typography>
                <NbaMatchupSubNav/>
                {showTrendFinder ?
                    <TrendFinder
                        currentMatchup={currentMatchup}
                        queryString={queryString}
                        handleChange={handleSdqlStringChange}
                        sport={sport}
                        teamTrends={teamTrends}
                        oTeamTrends={oTeamTrends}
                        seasonTrends={seasonTrends}
                        switchTeamAndOTeam={switchTeamAndOTeam}
                        setSwitchTeamAndOTeam={setSwitchTeamAndOTeam}
                    /> :
                    <ActiveTrendsRow
                        sport={sport}
                        teamDisplayName={teamDisplayName}
                        oTeamDisplayName={oTeamDisplayName}
                        teamActiveTrends={teamActiveTrends}
                        oTeamActiveTrends={oTeamActiveTrends}
                        overActiveTrends={overActiveTrends}
                        underActiveTrends={underActiveTrends}
                    />
                }
            </Box>
        </Fragment>

    )
}